import AppException from './AppException';
import BusinessException from './BusinessException';
import SessionOrUserNotExistException from './SessionOrUserNotExistException';
import showException from './showException';
import { CurrentUser } from './../user';
import NetworkException from "./NetworkException";

export default function defaultExceptionHandler(error) {
    if (error instanceof NetworkException){
        // NetworkException
        showException(error);
    } else if (error instanceof BusinessException) {
        // BusinessExcetpion 
        showException(error);
    } else if (error instanceof AppException) {
        // AppException
        showException(error);
    } else if (error instanceof SessionOrUserNotExistException) {
        if (!CurrentUser.isLoggedIn() && CurrentUser.isLoggedOut()) {
            return;
        }

        alert('登录超时，请重新登录！');
        CurrentUser.logout();
        location.reload();
    } else {
        // Ohter(NetworkError .... 等)
        showException(error);
    }
}
